import { X, Mail, Phone, FileText } from "lucide-react";
import { Link } from "react-router-dom";
import { useSettings } from "@/lib/SettingsContext";

const THEMES = [
  "Histoire de l'ésotérisme", "Arts divinatoires", "Ésotérisme & histoire de France",
  "Occultisme et personnages historiques", "Pierres et couronnes royales", "Médiumnité",
  "Deuil et croyances", "Rêves & onirothérapie",
];

export default function InviteModal({ open, onClose }) {
  const settings = useSettings();
  if (!open) return null;
  const email = settings?.appointment_email || "dorothee-medium@hotmail.fr";
  const phone = settings?.appointment_phone || "";

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4" data-testid="invite-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative z-10 w-full max-w-lg bg-[#0B1020] border border-[rgba(198,167,106,0.35)] dl-bubble max-h-[90vh] overflow-y-auto">
        <div className="p-8">
          <button data-testid="invite-close" onClick={onClose} className="absolute top-4 right-4 text-[#F3E9D2]/60 hover:text-[#F3E9D2]"><X size={22} /></button>
          <div className="dl-eyebrow mb-2">Conférences & interventions</div>
          <h2 className="serif text-3xl text-[#F3E9D2]">Inviter Dorothée en conférence</h2>
          <p className="text-sm text-[#F3E9D2]/60 mt-3">
            Pour toute demande d'intervention (salon, conférence, rencontre, événement), merci de préciser la date,
            le lieu et la thématique souhaitée.
          </p>

          <div className="mt-6 space-y-3">
            <a href={`mailto:${email}`} data-testid="invite-email" className="flex items-center gap-3 border border-[rgba(198,167,106,0.3)] px-4 py-3 hover:bg-white/[0.03] transition-colors">
              <Mail size={18} className="text-[#C6A76A]" /><span className="text-[#F3E9D2]">{email}</span>
            </a>
            {phone ? (
              <a href={`tel:${phone.replace(/\s/g, "")}`} className="flex items-center gap-3 border border-[rgba(198,167,106,0.3)] px-4 py-3 hover:bg-white/[0.03] transition-colors">
                <Phone size={18} className="text-[#C6A76A]" /><span className="text-[#F3E9D2]">{phone}</span>
              </a>
            ) : null}
          </div>

          <div className="mt-6">
            <div className="dl-eyebrow mb-3" style={{ fontSize: "0.6rem" }}>Thématiques proposées</div>
            <div className="flex flex-wrap gap-2">
              {THEMES.map((t) => <span key={t} className="text-xs border border-[rgba(198,167,106,0.25)] px-3 py-1.5 text-[#F3E9D2]/75">{t}</span>)}
            </div>
          </div>

          <Link to="/kit-media" onClick={onClose} className="dl-btn mt-7 w-full justify-center">
            <FileText size={15} /> Consulter le kit média
          </Link>
        </div>
      </div>
    </div>
  );
}
